import { css } from 'styled-components';

/**
 * Нейтральные цвета оболочки и главной карьерного раздела
 * (ТЗ «визуальное упрощение», 15.09).
 *
 * Владелец в Brave: слишком много цветных подложек и жирного. Насыщенный
 * жёлтый остаётся ОДНОЙ главной кнопке; мягкий жёлтый — активному пункту меню и
 * метке текущего этапа; всё остальное — текст, вторичный текст и тонкая линия.
 *
 * Значения — CSS-переменными с парой светлая/тёмная, тем же приёмом, что
 * `careerAccents`: литерал светлой темы в тёмной дал бы светлое пятно. Контраст
 * закреплён тестом `careerTokens.test.ts`.
 */
export type CareerTone = 'bg' | 'text' | 'text2' | 'line' | 'hover' | 'active' | 'done';

export const CAREER_TONES: CareerTone[] = [
  'bg',
  'text',
  'text2',
  'line',
  'hover',
  'active',
  'done',
];

export const TONE_LIGHT: Record<CareerTone, string> = {
  bg: '#FFFFFF',
  text: '#202124',
  text2: '#62666D',
  line: '#E5E7EB',
  hover: '#F5F6F7',
  active: '#FFF6C7',
  done: '#39734D',
};

export const TONE_DARK: Record<CareerTone, string> = {
  bg: '#141414',
  text: '#ECECEC',
  text2: '#B0B5BC',
  line: '#2C2C30',
  hover: '#1E1E1E',
  active: '#3A3316',
  done: '#7CC293',
};

/** Текст на жёлтой главной кнопке — один в обеих темах: кнопка жёлтая всегда. */
export const CTA_TEXT = '#202124';

const VAR_NAME: Record<CareerTone, string> = {
  bg: '--career-bg',
  text: '--career-text',
  text2: '--career-text-2',
  line: '--career-line',
  hover: '--career-hover',
  active: '--career-active',
  done: '--career-done',
};

const vars = (map: Record<CareerTone, string>) =>
  CAREER_TONES.map((tone) => `${VAR_NAME[tone]}: ${map[tone]};`).join('\n');

/** Объявление переменных — на корне раздела (`CareerLayout`). */
export const careerTokenVars = css`
  ${vars(TONE_LIGHT)}

  [data-theme='dark'] & {
    ${vars(TONE_DARK)}
  }
`;

export const careerColor = CAREER_TONES.reduce(
  (acc, tone) => ({ ...acc, [tone]: `var(${VAR_NAME[tone]}, ${TONE_LIGHT[tone]})` }),
  {} as Record<CareerTone, string>,
);
